import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import CharityEventTypesPage from "./charity-event-types-page";

export default (
  <Route path="charity-event-types">
    <Route
      index
      element={
        <Protected
          path="/admin/charity-event-types"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <CharityEventTypesPage />
        </Protected>
      }
    />
  </Route>
);
